// theme.ts
import { extendTheme } from "@chakra-ui/react";

const theme = extendTheme({
  colors: {
    brand: {
      50:  "#E3EDF7",
      100: "#C3D2EB",
      200: "#A2B6DF",
      300: "#829BD4",
      400: "#6281C8",
      500: "#4166BD",
      600: "#365299",
      700: "#2A3F75",
      800: "#1F2B51",
      900: "#14182D",
    },
    accent: {
      50:  "#FFF8E6",
      100: "#FFEDC4",
      200: "#FFE3A3",
      300: "#FFD980",
      400: "#FFCE5E",
      500: "#E6B741",
      600: "#B38F33",
      700: "#806925",
      800: "#4D4317",
      900: "#1A1C0A",
    },
    highlight: {
      50:  "#E8F7F7",
      100: "#BEEEEE",
      200: "#93E5E5",
      300: "#69DCDC",
      400: "#3ACFCF",
      500: "#28B3B3",
      600: "#1F8D8D",
      700: "#166767",
      800: "#0E4141",
      900: "#042020",
    },
    danger: {
      50:  "#FEE2E2",
      100: "#FECACA",
      200: "#FCA5A5",
      300: "#F87171",
      400: "#EF4444",
      500: "#DC2626",
      600: "#B91C1C",
      700: "#991B1B",
      800: "#7F1D1D",
      900: "#651111",
    },
    background: {
      light: "#F7F8FA",
      dark: "#1E2A35",
    },
    text: {
      primary: "#1E2A35",
      secondary: "#4A5568",
      inverted: "#F4F8FA",
    },
    landing: {
      midnight: "#1E1E2E",
      arctic: "#F9FAFB",
      emerald: "#00C896",
      sapphire: "#0057FF",
      graphite: "#6B7280",
      champagne: "#EFD493",
    },
  },

  shadows: {
    subtle: "0 1px 3px rgba(0, 0, 0, 0.08)",
    mid: "0 4px 12px rgba(0, 0, 0, 0.1)",
    deep: "0 10px 25px rgba(0, 0, 0, 0.15)",
    glow: "0 0 10px rgba(65, 102, 189, 0.2)", // softer, subtle focus glow
  },

  radii: {
    sm: "6px",
    md: "10px",
    lg: "16px",
    xl: "24px",
  },

  components: {
    Button: {
      baseStyle: {
        fontWeight: "600",
        borderRadius: "md",
        transition: "all 0.2s",
      },
      variants: {
        solid: {
          bg: "#EFA500", // Rich pastel-gold
          color: "white",
          _hover: { bg: "#d89000", boxShadow: "glow" },
          _active: { bg: "#b37400" },
        },
        accent: {
          bg: "#EFA500",
          color: "white",
          _hover: { bg: "#d89000", boxShadow: "glow" },
          _active: { bg: "#b37400" },
        },
        highlight: {
          bg: "#EFA500",
          color: "white",
          _hover: { bg: "#d89000", boxShadow: "glow" },
          _active: { bg: "#b37400" },
        },
        danger: {
          bg: "danger.400",
          color: "white",
          _hover: { bg: "danger.500", boxShadow: "subtle" },
          _active: { bg: "danger.600" },
        },
        ghost: {
          bg: "transparent",
          color: "text.secondary",
          _hover: { bg: "gray.100", color: "text.primary" },
          _active: { bg: "gray.200" },
        },
        outline: {
          borderWidth: "1px",
          borderColor: "brand.500",
          color: "brand.500",
          bg: "transparent",
          _hover: { bg: "brand.50" },
          _active: { bg: "brand.100" },
        },
      },
    },
    Card: {
      baseStyle: {
        bg: "white",
        borderRadius: "lg",
        boxShadow: "mid",
        p: 6,
      },
    },
  },

  fonts: {
    heading: `'Space Grotesk', 'Inter', sans-serif`,
    body: `'Inter', 'Satoshi', sans-serif`,
  },

  styles: {
    global: {
      "html, body": {
        bg: "background.light",
        color: "text.primary",
      },
      a: {
        color: "brand.500",
        _hover: { textDecoration: "underline" },
      },
    },
  },
});

export default theme;
